import type { RuleRuntimeEvidence } from "../../domain/ruleEvaluation";
import type { AppGlueStorageBackedConfig, RuleEvaluatorPort } from "../ruleIntegrationTypes";

export const createAppGlueRuntimeEvidence = (executableType: string): RuleRuntimeEvidence => ({
    runtime: "appglue_runtime",
    executableType,
});

export const withExecutableRuntimeEvidence = <
    Config extends AppGlueStorageBackedConfig,
    RuntimeRow = unknown,
>(
    executableType: string,
    evaluator: RuleEvaluatorPort<Config, RuntimeRow>,
): RuleEvaluatorPort<Config, RuntimeRow> => ({
    evaluate: (config, row, context) => ({
        ...evaluator.evaluate(config, row, context),
        runtimeEvidence: createAppGlueRuntimeEvidence(executableType),
    }),
});
